import { useEffect, useState } from 'react';
import type { FC } from 'react';

import { UserSession } from '@pp/core/src/config/UserSession';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';

import styles from './GameBackground.module.css';

const TABLE_ID = 'table_id',
  CASINO_ID = 'casino_id',
  OPERATOR_THEME = 'operator_theme';

const BASE_URL = `${window.location.origin}/desktop/assets/snaps`;

export const GameBackgroundConnected: FC = () => {
  const posterURL = usePosterImage();
  const dispatch = useCoreDispatch();

  useEffect(() => {
    if (posterURL) {
      dispatch(gameStateActions.setVideoPoster(posterURL));
    }
  }, [dispatch, posterURL]);

  return <div className={styles.gameBackground} />;
};

const usePosterImage = (): string => {
  const [posterUrl, setPosterUrl] = useState('');
  const userSession = UserSession.getSession();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tableId = params.get(TABLE_ID) || userSession?.tableId;
    const operatorTheme = params.get(OPERATOR_THEME) || userSession?.operatorTheme;
    const casinoId = params.get(CASINO_ID) || userSession?.casinoId;

    if (tableId) {
      const posterImageURL = `${BASE_URL}/${tableId}/${casinoId}/poster.jpg?v=${Math.random()}`;
      const defaultThemeURL = `${BASE_URL}/${tableId}/poster.jpg?v=${Math.random()}`;

      if (operatorTheme?.includes('default')) {
        setPosterUrl(defaultThemeURL);
        return;
      }
      const fetchPosterImage = async (posterUrl: string, isDefaultTheme = false): Promise<void> => {
        try {
          const response = await fetch(posterUrl);
          if (!response.ok) {
            throw new Error('Failed to fetch the poster image');
          }
          const blob = await response.blob();
          const imageObjectURL = URL.createObjectURL(blob);
          setPosterUrl(imageObjectURL);
        } catch (error) {
          if (isDefaultTheme) {
            console.error('Error fetching both themed and default poster images:', error);
          } else {
            fetchPosterImage(defaultThemeURL, true);
          }
        }
      };

      fetchPosterImage(posterImageURL);
    }
  }, []);

  return posterUrl;
};
